import { APIVersion, AuthenticatedRequest, BasicRequest, HTTPMethod } from "../requests/request";
import { Device } from "../models";

export enum DeviceTokenProvider {
    Apple = 'apple',
    Google = 'google'
}

export type DeviceData = {
    'app_version': string,
    'build_version': string,
    'device_token'?: string,
    'token_provider'?: DeviceTokenProvider,
    'device_uuid': string,
    'device_data_os'?: string,
    'device_data_os_version'?: string,
    'device_data_device_type'?: string,
    'device_data_device_name'?: string,
    'device_data_device_category'?: string,
    'debug': boolean,
    'language': string
}

export class API {

    /**
     * Registers a new device with the provided data
     * @returns {Promise<User>} The Promise contains either a device or an APIError if rejected
     */
    public static updateDevice(data: DeviceData, refresh_token: string): Promise<Device> {
        let apiRequest = new BasicRequest<Device>('/devices/' + data.device_uuid, HTTPMethod.PUT, APIVersion.v1_0, undefined, data);
        apiRequest.refresh_token = refresh_token;
        return apiRequest.send(Device).then((data): Device => {
            return <Device>data.data
        })
    }

    /**
     * Deletes the device
     * @param {string} uuid
     * @returns {Promise<void>} The Promise contains either an APIError if rejected
     */
    public static deleteDevice(uuid: string): Promise<void> {
        let apiRequest = new AuthenticatedRequest<void>('/devices/' + uuid, HTTPMethod.DELETE, APIVersion.v1_0);
        return apiRequest.send().then(() => {
            return void 0;
        })
    }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/devices.ts